import type { PhysicalThing } from "../physicalThing";
import { deserializeXY } from "../serialization";
import { RobotActorState } from "../interfaces";
import type { XY } from "../xy";
import { Robot } from "./robot";
import { CaveRobotCorpse } from "./caveRobotCorpse";

export class CaveRobot extends Robot {
	static key = "CaveRobot";
	constructor(xy: XY, state: RobotActorState = RobotActorState.WANDERING) {
		super(xy, state);
	}

	generateCorpse(): PhysicalThing | null {
		return new CaveRobotCorpse(this.xy);
	}

	static deserialize(data: any): CaveRobot {
		const m = new CaveRobot(deserializeXY(data.xy), data.state);
		m.restoreMobFields(data);
		m.ai.restoreFrom(data.ai);
		return m;
	}
}
